import React from "react";
import { useNavigate } from "react-router-dom";
import PageTitle from "../../components/PageTitle";
import { Card } from "../../components/ui/Card";
import { motion } from "framer-motion";
import { FiRefreshCw, FiCheckSquare, FiBarChart2, FiTrendingUp, FiPrinter } from "react-icons/fi";

const Academic = () => {
  const navigate = useNavigate();

  const academicItems = [
    {
      title: "Change Programme",
      description: "Request a change of your current academic programme or department.",
      icon: FiRefreshCw,
      path: "/app/change-programme",
      color: "bg-primary-100 text-primary-600",
    },
    {
      title: "Registered Modules",
      description: "Review and manage the academic modules you have registered for.",
      icon: FiCheckSquare,
      path: "/app/registered-modules",
      color: "bg-success-100 text-success-600",
    },
    {
      title: "Academic Results",
      description: "View and print your official semester results and transcripts.",
      icon: FiBarChart2,
      path: "/app/result",
      color: "bg-warning-100 text-warning-600",
    },
    {
      title: "Academic Progression",
      description: "Monitor your overall academic journey and progression status.",
      icon: FiTrendingUp,
      path: "/app/progression",
      color: "bg-blue-100 text-blue-600",
    },
    {
      title: "Modules Form",
      description: "Download and print your official semester module registration form.",
      icon: FiPrinter,
      path: "/app/module-form",
      color: "bg-purple-100 text-purple-600",
    },
  ];

  return (
    <div className="animate-fade-in">
      <PageTitle
        title="Academic Center"
        sub="Access your academic records, registrations, and results easily."
      />

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 mt-6">
        {academicItems.map((item, i) => {
          const Icon = item.icon;
          return (
            <motion.div
              key={item.path}
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: i * 0.1 }}
            >
              <Card
                onClick={() => navigate(item.path)}
                className="group relative cursor-pointer hover:-translate-y-2 transition-all duration-300"
                padding="lg"
              >
                <div className={`w-[60px] h-[60px] rounded-2xl flex items-center justify-center mb-6 transition-all ${item.color}`}>
                  <Icon className="w-6 h-6" />
                </div>
                <h3 className="text-xl font-bold text-neutral-900 mb-2">{item.title}</h3>
                <p className="text-sm text-neutral-500 leading-relaxed m-0">{item.description}</p>
                <div className="absolute bottom-6 right-6 w-8 h-8 rounded-full bg-white border border-neutral-100 flex items-center justify-center text-neutral-400 group-hover:bg-primary-500 group-hover:text-white group-hover:translate-x-1 transition-all">
                  <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                  </svg>
                </div>
              </Card>
            </motion.div>
          );
        })}
      </div>
    </div>
  );
};

export default Academic;
